import {
  ConfigurationType,
  SystemOptionType,
  ValidSystemType
} from 'data/types';

export function buildSystemsForSwappedOption(
  option: SystemOptionType,
  fullConfig: ConfigurationType,
  filteredIndexMap: Record<string, number | null>,
  overrides: Record<string, ValidSystemType>,
  swappedCondenserUniqueId: string,
  targetSystem: ValidSystemType
): ValidSystemType[] {
  const systems: ValidSystemType[] = [];
  option.configuration.condensers.forEach((cond) => {
    if (cond.uniqueId === swappedCondenserUniqueId) {
      systems.push(targetSystem);
      return;
    }
    const override = overrides[cond.uniqueId];
    if (override) {
      systems.push(override);
      return;
    }
    const fc = fullConfig.condensers.find((c) => c.uniqueId === cond.uniqueId);
    const idx = filteredIndexMap[cond.uniqueId];
    const system =
      idx === null || idx === undefined ? null : fc?.validSystems[idx] ?? null;
    if (system) {
      systems.push(system);
    }
  });
  return systems;
}

export function resolveCustomSystemName(
  option: SystemOptionType,
  existingCustomNames: string[]
): string {
  if (option.tags.includes('Custom')) return option.name;
  const taken = new Set(existingCustomNames);
  let systemNumber = 1;
  while (taken.has(`Custom System ${systemNumber}`)) {
    systemNumber += 1;
  }
  return `Custom System ${systemNumber}`;
}
